import { render, staticRenderFns } from "./CompanyFinancialData.vue?vue&type=template&id=290a8f74&scoped=true&"
import script from "./CompanyFinancialData.vue?vue&type=script&lang=ts&"
export * from "./CompanyFinancialData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290a8f74",
  null
  
)

export default component.exports